import { z } from "zod"

// Runtime counterpart to the compile-time types in dataPointTypes.ts.
// openapi-typescript only buys compile-time safety — a real backend
// contract change wouldn't be caught until something broke at render time.
// These parse actual API responses so a mismatch surfaces immediately, as
// a thrown error react-query can report via `isError`.

export const tagPathSchema = z.object({
  tag: z.string().nullish(),
  historyProvider: z.string().nullish(),
  driver: z.string().nullish(),
  folder: z.boolean().nullish(),
})

export const dataPointValueSchema = z.object({
  timestamp: z.string(),
  value: z.number().nullable(),
})

export const dataPointSchema = z.object({
  $type: z.literal("tag"),
  id: z.number(),
  name: z.string(),
  locationId: z.number(),
  location: z.string().nullish(),
  unitId: z.number(),
  description: z.string(),
  instrument: z.string(),
  path: tagPathSchema.nullish(),
})
